import React, { useContext } from 'react';

import { ListContext } from '@contexts/ListContext';

import NwSelect from '@components/Gui/NwForm/CustomSelect';

const BankAccountsSelector = ({ value, onChange, onBlur }) => {
    const { cachedList } = useContext(ListContext);
    const options = cachedList.bankAccounts.items.map((item) => ({
        label: item.BankName,
        value: item.ID,
        key: item.ID,
    }));

    return (
        <NwSelect
            width="100%"
            mode="single"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            options={options}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
        />
    );
};
export default BankAccountsSelector;
